// extracted by mini-css-extract-plugin
export default {"termAndConditionCard":"Style_termAndConditionCard__iztu0","titleSub":"Style_titleSub__bNeMe","content":"Style_content__lr9AL"};